<template>
  <div
    class="mask"
    @click.self="clickClose('close')"
    v-if="maskSatus"
  >
    <div class="box">
      <div class="option">
        <div class="item">
          <div class="title">日期</div>
          <ul>
            <li
              v-for="(item, index) in saleDateInfos"
              :class="{
                currentDate: !item.ticketState,
                currentTicket: currentIndex1 === index,
              }"
              class="item-days"
              @click="clickDays(item, index)"
              :key="item.saleDate"
            >
              <span class="currentDay">{{ $getDays(item.saleDate) }}</span>
              <time>{{ $sieveMonthDay(item.saleDate) }}</time>
              <img v-if="currentIndex1 === index" src="~@/assets/image/common/common_select.png" alt="">
            </li>
            <li
              v-for="index in complement"
              :key="index"
              class="hide"
            ></li>
          </ul>
        </div>
        <div class="item">
          <div class="title">
            <span>时段</span>
            <em>仅限入园时间，园内游玩时间不限</em>
          </div>
          <ul>
            <li
              v-for="(item1, index1) in currentDatePeriodInfos"
              :key="item1.periodId"
              :class="{
                'currentTicket': currentIndex2 === index1,
                'currentDate' : parseInt(item1.resourceCount) === 0
              }"
              @click="clickTimeInterval(item1, index1)"
            >
              <span class="timeSlot">{{ item1.periodStartTime }}~{{ item1.periodEndTime }}</span>
              <time>{{ item1.resourceCount > 0 ? '有余票' : '已售罄' }}</time>
              <img v-if="currentIndex2 === index1" src="~@/assets/image/common/common_select.png" alt="">
            </li>
            <li
              v-for="index in 4 - currentDatePeriodInfos.length"
              :key="index"
              class="hide"
            ></li>
          </ul>
        </div>
        <div class="clickChoice">
          <div @click="clickClose('close')">取消</div>
          <div @click="clickClose('confirm')">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "moredate",
  props: ["saleDateInfos", "maskSatus", "currentGroup"],
  data() {
    return {
      currentIndex1: null,
      currentIndex2: null,
      currentDatePeriodInfos: [],
      selectItem: null,
      selectGroup: null,
      complement: 0
    };
  },
  methods: {
    clickDays(item, index) {
      if(item.isClosed) {
        return this.$toast('周一园内景点闭馆')
      }
      if(!item.datePeriodInfos.length)return this.$toast('当日已止票');
      if(item.datePeriodInfos.every((v) => parseInt(v.resourceCount) <= 0))return this.$toast("余票不足");
      this.currentDatePeriodInfos = item.datePeriodInfos;
      this.currentIndex1 = index;
      this.currentIndex2 = null;
      this.selectItem = item;
    },
    clickTimeInterval(periodStartTime, index) {
      if (parseInt(periodStartTime.resourceCount) < 1)return this.$toast("暂无余票");
      this.selectGroup = periodStartTime;
      this.currentIndex2 = index;
    },
    clickClose(type = null) {
      if (type === "confirm") {
        if (this.currentIndex2 === null)return this.$toast("请选择时段");
        if(!this.selectGroup){
          this.selectGroup = this.selectItem.datePeriodInfos[this.currentIndex2];
        };
        return this.$emit("clickClose", {
          currentIndex1: this.currentIndex1,
          currentIndex2: this.currentIndex2,
          selectItem: this.selectItem,
          selectGroup: this.selectGroup,
        });
      };
      this.$emit("clickClose");
    },
  },
  watch: {
    currentGroup: {
      handler(newValue){
        const currentDays = JSON.parse(JSON.stringify(newValue.currentDays));
        if(!currentDays)return;
        const currentTime = JSON.parse(JSON.stringify(newValue.currentTime));
        this.currentDatePeriodInfos = currentDays.datePeriodInfos;
        this.selectItem = currentDays;
        currentTime ? (this.selectGroup = currentTime[newValue.activeTimeInterval]) : null;
        this.currentIndex1 = this.saleDateInfos.findIndex(v => v.saleDate === newValue.currentDays.saleDate);
        this.currentIndex2 = newValue.activeTimeInterval;
      },
      immediate: true,
    },
    maskSatus(newValue){
      this.$beyondHiding(newValue)
    },
    saleDateInfos(newValue){
      this.complement = this.$offsetCalculation(newValue.length, 4);
    }
  },
};
</script>

<style scoped lang='less'>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.46);
  z-index: 9999;
  .box {
    left: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    background: #ffffff;
    border-radius: 0.32rem * 2 0.32rem * 2 0 0;
    .option {
      padding: 0.8rem 0 0;
      .item {
        padding: 0 0.346667rem;
        &:nth-child(2) {
          margin: 0.8rem - 0.213333rem 0 1.333333rem;
        }
        .title {
          color: #222328;
          font-size: 0.24rem * 2;
          font-weight: bold;
          em {
            font-size: 0.32rem;
            font-weight: 400;
            color: rgba(58, 62, 92, 0.7);
            margin-left: 0.266667rem;
          }
        }
        ul {
          margin-top: 0.32rem;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          li {
            width: 2.133333rem;
            height: 0.746667rem * 2;
            margin-right: 0.213333rem;
            border: 1px solid rgba(151, 151, 151, 0.07);
            border-radius: 0.16rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 0.266667rem;
            box-shadow: 0 0.026667rem 0.053333rem 0 rgba(0, 0, 0, 0.06);
            color: #333333;
            &:nth-child(4n) {
              margin-right: 0;
            }
            .currentDay {
              font-size: 0.453334rem;
              line-height: 0.373333rem;
            }
            time{
              font-size: 0.373333rem;
              line-height: 0.533333rem;
            }
            .timeSlot {
              margin-bottom: 0.266667rem;
            }
          }
          .item-days {
            font-size: 0.266667rem;
            margin-bottom: 0.213333rem;
          }
        }
      }
    }
  }
}

.hide {
  visibility: hidden;
}
.currentDate {
  background: rgba(153, 153, 153, 0.5);
  & > * {
    color: #ffffff !important;
  }
}
.currentTicket {
  color: #3B6D9C !important;
  border: 1px solid #3B6D9C !important;
  position: relative;
  background: #F1F5F8;
  box-shadow: 0 .053333rem .106667rem 0 rgba(0, 0, 0, 0.06);
  img{
    width: .346667rem;
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
.clickChoice {
  display: flex;
  color: #ffffff;
  font-size: 0.213333rem * 2;
  text-align: center;
  line-height: 1.6rem;
  div:first-child {
    background: rgba(153, 153, 153, 0.5);
    width: 1.92rem * 2;
  }
  div:last-child {
    background: #3B6D9C;
    flex: 1;
  }
}
</style>
